import { render, staticRenderFns } from "./homeLocker.vue?vue&type=template&id=620edd29"
import script from "./homeLocker.vue?vue&type=script&lang=js"
export * from "./homeLocker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports